import { render, staticRenderFns } from "./expenses-reports.vue?vue&type=template&id=1db59e3b"
import script from "./expenses-reports.vue?vue&type=script&lang=js"
export * from "./expenses-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports